import { render } from "./EmployeeShow.vue?vue&type=template&id=41796356&scoped=true"
import script from "./EmployeeShow.vue?vue&type=script&lang=js"
export * from "./EmployeeShow.vue?vue&type=script&lang=js"

import "./EmployeeShow.vue?vue&type=style&index=0&id=41796356&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41796356"]])

export default __exports__